import { useStyles } from "../context";
import {
  CorePackagesComponent,
  CORE_PACKAGES_NAME,
} from "@b2bportal/core-types";

export const usePackagesStyles = (
  componentName: keyof typeof CorePackagesComponent,
  defaultStyles?: object
) => {
  return useStyles(CORE_PACKAGES_NAME, componentName, defaultStyles);
};
